import 'vant/es/icon/style';
import guizebeijing from '../../assets/guizebeijing.png';
import jinjiang from '../../assets/jinjiang.png';
import yinjiang from '../../assets/yinjiang.png';
import tongjiang from '../../assets/tongjiang.png';
import youxiuchuangzuozhe from '../../assets/youxiuchuangzuozhe.png';
import jiantou from '../../assets/jiantou.png';
import errorIcon from '../../assets/error.png';
import groupScan from '../../assets/groupScan.png';
export default {
  name: 'CreatorContestRules',
  data: function data() {
    return {
      guizebeijing: guizebeijing,
      jinjiang: jinjiang,
      yinjiang: yinjiang,
      tongjiang: tongjiang,
      youxiuchuangzuozhe: youxiuchuangzuozhe,
      jiantou: jiantou,
      errorIcon: errorIcon,
      groupScan: groupScan
    };
  },
  computed: {
    pageBgStyle: function pageBgStyle() {
      return {
        backgroundImage: "url('".concat(this.guizebeijing, "')"),
        backgroundRepeat: 'repeat-y',
        backgroundPosition: 'top center',
        backgroundSize: '100% auto'
      };
    },
    goldBgStyle: function goldBgStyle() {
      return {
        backgroundImage: "url('".concat(this.jinjiang, "')"),
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: '100% 100%'
      };
    },
    silverBgStyle: function silverBgStyle() {
      return {
        backgroundImage: "url('".concat(this.yinjiang, "')"),
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: '100% 100%'
      };
    },
    bronzeBgStyle: function bronzeBgStyle() {
      return {
        backgroundImage: "url('".concat(this.tongjiang, "')"),
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: '100% 100%'
      };
    },
    plainBgStyle: function plainBgStyle() {
      return {
        backgroundImage: "url('".concat(this.youxiuchuangzuozhe, "')"),
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: '100% 100%'
      };
    }
  },
  methods: {
    onBack: function onBack() {
      if (this.$router) {
        this.$router.back();
        return;
      }
      history.back();
    }
  }
};